/**
 * The rows of the two side panes: the folded sidebar at the left edge of the window
 * (`app-shell.tsx`) and the phone's rail at the right (`softphone/softphone-dock.tsx`).
 *
 * Both are a column of icons 56px wide, and the two are read against each other across the page,
 * so they are built from the same sizes and start level: the phone's button is beside the
 * sidebar's first link. They were set separately once, a row of 2.25rem here and a cell of 3rem
 * there starting a head higher, and no two icons were level. The rail then sets its buttons a
 * little further apart than the sidebar sets its links (`RAIL_GAP` in `softphone/rail.ts`), so
 * the rows under the first are no longer level with the sidebar's.
 */

/** A pane's head: the sidebar's logo and its fold button. The rail has nothing of its own for
 *  it and keeps the same band clear, beside the end of the frame's top pane. */
export const PANE_HEAD = "h-12";

/** The room between a pane's head and its first row. */
export const PANE_LIST_TOP = "pt-4";

/** One row: a link of the folded sidebar, a button of the rail. */
export const PANE_ROW = "h-9";

/** The gap between two links of the sidebar, set on the list that holds them. The rail has its
 *  own (`RAIL_GAP`). */
export const PANE_ROW_GAP = "gap-0.5";
